export default class alertasService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
			"all": '/api/tipo_incidencia',
			"id": '/api/tipo_incidencia/:id',
			"new": '/api/tipo_incidencia',
			'delete': '/api/tipo_incidencia/:id',
            "update": '/api/tipo_incidencia',
		};
	}

	getAll(filter){
		let url = this.baseUrl + this.routes.all;
		let config = {
			params : filter
		};
		return this.http.get(url, config);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}

	delete(objId){
	     	let idRoute = this.routes.delete.replace(':id', objId._id);
	     	let url = this.baseUrl + idRoute;
	        return this.http.delete(url);
	}

	update(data){
	        let url = this.baseUrl + this.routes.update;
	        return this.http.put(url, data);
	}
}



// WEBPACK FOOTER //
// ./app/js/services/tipoIncidenciaService.js